export class PartnerData {
    name: string;
}
